/* Endurrad — CONFRONTA (20/10/2026). File aggiunto: sopravvive agli aggiornamenti del tema.
   Caricato da snippets/endurrad-app-stile.liquid. Stile: assets/endurrad-confronta.css
   Famiglie: fari, borse crash bar, valigie laterali, top case, borse serbatoio (snippets/erd-confronta-cat.liquid, dal Tipo prodotto).
   - Casella «Confronta» sulle schede delle griglie (snippets/erd-card.liquid) e pulsante nella scheda prodotto (inserito qui).
   - Fino a 4 prodotti per famiglia, ricordati nel browser (localStorage «erd_confronto»); la barra in basso mostra la famiglia in uso.
   - Tabella: dati letti da /products/<handle>?view=erd-confronta (templates/product.erd-confronta.liquid).
     Le righe di ogni famiglia si costruiscono dalle specifiche della scheda (loboo.specifiche o scheda.specifiche) cercando
     le etichette con le espressioni qui sotto: per aggiungere o rinominare una riga basta modificare FAMIGLIE.
     «Altre specifiche» mostra tutto il resto; «Solo differenze» nasconde le righe uguali su tutti i prodotti. */
(function () {
  var MAX = 4, CHIAVE = 'erd_confronto';
  var FAMIGLIE = {
    'fari': { nome: 'Fari e faretti', altri: 'altri fari', url: '/collections/fari-supplementari-moto', righe: [
      ['Flusso luminoso', /^flusso (luminoso|per faretto|per coppia)|^flusso$/],
      ['Portata e fascio', /portata|prestazioni del fascio|tipo di fascio|^fasci|fascio spot|ottica|sistema lenti|gruppo ottico/],
      ['Potenza', /potenza|assorbiment/],
      ['Temperatura colore', /temperatura colore/],
      ['Omologazione', /omologaz|certificato ece|approvazion|conformit|classi e marcatura/],
      ['Protezione', /^protezione|grado ip|misure e protezione/],
      ['Alimentazione', /tension|alimentaz/],
      ['Modalità e funzioni', /^modalit|^funzioni|^controllo|^drl|livelli di intensit/],
      ['Misure', /^misure|ingombro|^dimension|diametro (corpo|frontale)|altezza con (morsetto|staffa)|^profondit/],
      ['Peso', /^peso/],
      ['Nella confezione', /contenuto|nella confezione|fari inclusi|faretto compreso/],
      ['Garanzia produttore', /garanzia/]
    ] },
    'borse-crash-bar': { nome: 'Borse crash bar', altri: 'altre borse crash bar', url: '/collections/borse-paramotore-crash-bar', righe: [
      ['Capacità', /capacit|^volume/],
      ['Misure', /^dimension|ingombro|^lunghezza/],
      ['Peso', /^peso/],
      ['Portata massima', /portata|carico/],
      ['Impermeabilità', /impermeab|tenuta|grado/],
      ['Tessuto', /tessuto|corpo borsa|material/],
      ['Diametro barra', /diametro/],
      ['Fissaggio', /fissaggio|sgancio rapido|punto di fissaggio/],
      ['Antifurto', /antifurto|serratur/],
      ['Nella confezione', /confezione|^borse$|sacche interne/]
    ] },
    'valigie': { nome: 'Valigie laterali', altri: 'altre valigie', url: '/collections/valigie-laterali', righe: [
      ['Capacità', /volume totale|volume coppia|^configurazion|^volume|capacit/],
      ['Materiale', /materiale valigie|^materiale$|^materiali$|^tessuto/],
      ['Impermeabilità', /impermeab|tenuta all|grado ip/],
      ['Peso', /coppia di valigie|valigie vuote|peso (della )?coppia|peso del set|^pesi$|^peso/],
      ['Misure interne', /^interno valigia sinistra|dimensioni interne|^interno p35|dimensioni valigia|dimensioni prodotto|^valigia sinistra 35/],
      ['Serratura', /serratur|^chiusura|antifurto|^sicurezza$/],
      ['Telai', /telai laterali|^telai$|telaio laterale|^contenuto$|composizione del kit/],
      ['Carico per valigia', /carico/],
      ['Garanzia produttore', /garanzia/]
    ] },
    'top-case': { nome: 'Top case', altri: 'altri top case', url: '/collections/bauletti-top-case-moto', righe: [
      ['Capacità', /^volume|capacit/],
      ['Materiale', /^material/],
      ['Peso', /^peso|dimensioni.peso/],
      ['Carico massimo', /carico|portata/],
      ['Impermeabilità', /impermeab|tenuta/],
      ['Serratura', /serratur|^chiusura|antifurto|^sicurezza$/],
      ['Aggancio', /aggancio|^fissaggio|^montaggio/],
      ['Misure', /^misure|^dimension/],
      ['Garanzia produttore', /garanzia/]
    ] },
    'borse-serbatoio': { nome: 'Borse serbatoio', altri: 'altre borse serbatoio', url: '/collections/borsa-serbatoio', righe: [
      ['Capacità', /^volume$|volume base|volume chiusa|capacit/],
      ['Espandibile', /volume massimo|volume espansa|espansion/],
      ['Aggancio', /sistema di aggancio|^sistema$|sistema di fissaggio|attrazione magnetica|^interfaccia/],
      ['Flangia o anello', /flangia|anello/],
      ['Misure', /^dimension|ingombro/],
      ['Peso', /^peso/],
      ['Impermeabilità', /grado ip|impermeab/],
      ['Copertura antipioggia', /antipioggia/],
      ['Tessuto', /tessuto|composizion/],
      ['Spazio manubrio-tappo', /distanza minima|spazio minimo/]
    ] }
  };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').trim().toLowerCase().replace(/ +/g, ' '); }
  var euro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  function soldi(c) { return euro.format((c || 0) / 100); }

  /* ---------- Stato ---------- */
  function leggi() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(CHIAVE) || 'null'); } catch (e) {}
    if (!s || typeof s !== 'object' || !s.liste) s = { cat: '', liste: {} };
    /* 21/10/2026: si scartano anche le liste vuote, e la famiglia in uso deve avere almeno un prodotto */
    Object.keys(s.liste).forEach(function (k) { if (!FAMIGLIE[k] || !Array.isArray(s.liste[k]) || !s.liste[k].length) delete s.liste[k]; });
    if (!s.cat || !s.liste[s.cat]) s.cat = Object.keys(s.liste)[0] || '';
    return s;
  }
  var stato = leggi();
  /* prima famiglia che ha almeno un prodotto (o nessuna) */
  function primaPiena() { return Object.keys(stato.liste).filter(function (k) { return stato.liste[k] && stato.liste[k].length; })[0] || ''; }
  function salva() {
    Object.keys(stato.liste).forEach(function (k) { if (!stato.liste[k] || !stato.liste[k].length) delete stato.liste[k]; });
    try { localStorage.setItem(CHIAVE, JSON.stringify(stato)); } catch (e) {}
  }
  function lista(cat) { return stato.liste[cat] || (stato.liste[cat] = []); }
  /* sola lettura: non crea liste vuote */
  function dentro(cat, h) { return (stato.liste[cat] || []).some(function (x) { return x.h === h; }); }

  function aggiungi(cat, item) {
    var l = lista(cat);
    stato.cat = cat;
    if (dentro(cat, item.h)) { salva(); aggiorna(); return true; }
    if (l.length >= MAX) { avviso('Puoi confrontare fino a ' + MAX + ' prodotti: togline uno dalla barra.'); aggiorna(); return false; }
    l.push(item); salva(); aggiorna();
    return true;
  }
  function togli(cat, h) {
    stato.liste[cat] = lista(cat).filter(function (x) { return x.h !== h; });
    if (!stato.liste[cat].length) {
      delete stato.liste[cat];
      if (stato.cat === cat) stato.cat = primaPiena();
    }
    salva(); aggiorna();
  }

  /* ---------- Barra in basso ---------- */
  var bar = null, msgT = null;
  function creaBarra() {
    bar = document.createElement('div');
    bar.className = 'erd-cmp-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Prodotti da confrontare');
    bar.innerHTML = '<p class="erd-cmp-bar__msg" data-msg hidden role="status"></p><div class="erd-cmp-bar__t"><b data-nome></b><span data-n></span></div>' +
      '<div class="erd-cmp-bar__th" data-th></div><button type="button" class="erd-cmp-bar__go" data-go>Confronta</button>' +
      '<button type="button" class="erd-cmp-bar__x" data-svuota aria-label="Svuota il confronto">×</button>';
    document.body.appendChild(bar);
    $('[data-go]', bar).addEventListener('click', function () { apriConfronto(stato.cat); });
    $('[data-svuota]', bar).addEventListener('click', function () { delete stato.liste[stato.cat]; stato.cat = primaPiena(); salva(); aggiorna(); });
    $('[data-th]', bar).addEventListener('click', function (e) { var b = e.target.closest('[data-rm]'); if (b) togli(stato.cat, b.getAttribute('data-rm')); });
  }
  function avviso(t) {
    if (!bar) creaBarra();
    var m = $('[data-msg]', bar);
    m.textContent = t; m.hidden = false;
    bar.classList.add('is-on'); bar.removeAttribute('aria-hidden');
    clearTimeout(msgT); msgT = setTimeout(function () { m.hidden = true; aggiorna(); }, 3200);
  }
  function aggiorna() {
    /* la barra mostra sempre una famiglia con prodotti; senza prodotti resta nascosta (e non cliccabile) */
    if (!stato.cat || !(stato.liste[stato.cat] || []).length) { var pp = primaPiena(); if (pp) stato.cat = pp; }
    var cat = stato.cat, l = cat ? (stato.liste[cat] || []) : [];
    if (!bar) creaBarra();
    var m = $('[data-msg]', bar);
    var acceso = l.length > 0 || !m.hidden;
    bar.classList.toggle('is-on', acceso);
    if (acceso) bar.removeAttribute('aria-hidden'); else bar.setAttribute('aria-hidden', 'true');
    if (cat && FAMIGLIE[cat]) {
      $('[data-nome]', bar).textContent = FAMIGLIE[cat].nome;
      $('[data-n]', bar).textContent = l.length + ' di ' + MAX + ' scelti';
      var th = '';
      for (var i = 0; i < MAX; i++) {
        var x = l[i];
        th += x ? '<span>' + (x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.t) + '" loading="lazy">' : '') + '<button type="button" data-rm="' + esc(x.h) + '" aria-label="Togli ' + esc(x.t) + '">×</button></span>' : '<em aria-hidden="true"></em>';
      }
      $('[data-th]', bar).innerHTML = th;
      var go = $('[data-go]', bar);
      go.disabled = l.length < 2;
      go.textContent = l.length < 2 ? 'Scegline almeno 2' : 'Confronta (' + l.length + ')';
    }
    /* caselle e pulsanti già nella pagina */
    $$('[data-erd-cmp]').forEach(function (c) { c.checked = dentro(c.getAttribute('data-cat'), c.getAttribute('data-erd-cmp')); });
    var pb = $('[data-erd-cmp-pdp]');
    if (pb) {
      var on = dentro(pb.getAttribute('data-cat'), pb.getAttribute('data-h'));
      pb.classList.toggle('is-on', on);
      pb.setAttribute('aria-pressed', on ? 'true' : 'false');
      $('i', pb).textContent = on ? '✓ Nel confronto' : 'Confronta';
    }
  }

  /* Caselle «Confronta» sulle schede (anche quelle caricate dopo) */
  document.addEventListener('change', function (e) {
    var c = e.target;
    if (!c.matches || !c.matches('[data-erd-cmp]')) return;
    var cat = c.getAttribute('data-cat'), h = c.getAttribute('data-erd-cmp');
    if (!FAMIGLIE[cat]) return;
    if (c.checked) { if (!aggiungi(cat, { h: h, t: c.getAttribute('data-titolo') || h, i: c.getAttribute('data-img') || '' })) c.checked = false; }
    else togli(cat, h);
  });
  var mo = null;
  if ('MutationObserver' in window) {
    var t0 = null;
    mo = new MutationObserver(function () { clearTimeout(t0); t0 = setTimeout(function () { $$('[data-erd-cmp]').forEach(function (c) { c.checked = dentro(c.getAttribute('data-cat'), c.getAttribute('data-erd-cmp')); }); }, 150); });
  }

  /* Pulsante nella scheda prodotto: dati da snippets/endurrad-app-stile.liquid (#erd-cmp-pdp) */
  function pulsantePdp() {
    var d = $('#erd-cmp-pdp'), dati = null;
    if (!d) return;
    try { dati = JSON.parse(d.textContent); } catch (e) { return; }
    if (!dati || !FAMIGLIE[dati.cat]) return;
    var dove = $('[data-erd-buy] .erd-pp__help') || $('[data-erd-buy] .erd-pp__trust') || $('[data-erd-buy]');
    if (!dove) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'erd-cmp-pdp';
    b.setAttribute('data-erd-cmp-pdp', '');
    b.setAttribute('data-cat', dati.cat);
    b.setAttribute('data-h', dati.h);
    b.innerHTML = '<span><b>Confronta con ' + esc(FAMIGLIE[dati.cat].altri) + '</b><small>Prezzo, misure e caratteristiche fianco a fianco, fino a ' + MAX + ' modelli</small></span><i>Confronta</i>';
    if (dove.matches('[data-erd-buy]')) dove.appendChild(b); else dove.parentNode.insertBefore(b, dove.nextSibling);
    b.addEventListener('click', function () {
      if (dentro(dati.cat, dati.h)) togli(dati.cat, dati.h);
      else if (aggiungi(dati.cat, { h: dati.h, t: dati.t, i: dati.i })) {
        if (lista(dati.cat).length < 2) avviso('Aggiunto. Ora scegli ' + FAMIGLIE[dati.cat].altri + ' da confrontare.');
      }
    });
  }

  /* La barra sale quando c'è la barra fissa di acquisto della scheda prodotto */
  function barraAcquisto() {
    var b = $('[data-erd-bar]');
    if (!bar) return;
    bar.classList.toggle('is-alto', !!(b && b.classList.contains('is-on')));
  }

  /* ---------- Finestra del confronto ---------- */
  var cache = {}, dlg = null;
  /* Anteprima di un tema non pubblicato (o editor del tema): le richieste devono andare allo stesso tema */
  function suffissoTema() {
    try { var t = window.Shopify && Shopify.theme; if (t && t.id && t.role !== 'main') return '&preview_theme_id=' + t.id; } catch (e) {}
    return '';
  }
  /* Dati base da /products/<handle>.js se la vista del confronto non risponde (es. tema senza il template) */
  function base(h) {
    return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (r.status === 404) return { mancante: true }; if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        if (p.mancante) return p;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
        var marca = String(p.vendor || '').toUpperCase();
        return { handle: p.handle, id: p.id, title: p.title, vendor: p.vendor, codice: v.sku || '', type: p.type, cat: '', url: '/products/' + p.handle,
          img: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500' : null,
          price: v.price || p.price, compare: v.compare_at_price || 0, priceVaries: !!p.price_varies, priceMin: p.price_min,
          available: !!p.available, variantId: v.id, variants: (p.variants || []).length, qty: null, pre: false,
          veloce: ['LOBOO', 'JADO', 'CHIGEE', 'ENDURRAD'].indexOf(marca) > -1, rating: 0, ratingCount: 0, modelli: '', universale: false,
          chiave: [], specs: [], parziale: true };
      })
      .catch(function () { return null; });
  }
  function dati(h) {
    if (cache[h]) return cache[h];
    /* senza intestazione Accept: con «application/json» Shopify risponde con il JSON standard del prodotto e ignora la vista */
    cache[h] = fetch('/products/' + encodeURIComponent(h) + '?view=erd-confronta' + suffissoTema())
      .then(function (r) { if (r.status === 404) return { mancante: true }; if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var j = typeof t === 'string' ? JSON.parse(t) : t; if (!j.mancante && !j.handle) throw new Error('vista'); return j; })
      .catch(function () { return base(h); })
      .then(function (p) { if (!p || p.parziale) delete cache[h]; return p; });
    return cache[h];
  }
  function moto() {
    var m = null;
    try { m = JSON.parse(localStorage.getItem('erd_moto_sel') || 'null'); } catch (e) {}
    return m && m.base ? { base: m.base, nome: (m.marca ? m.marca + ' ' : '') + m.base } : null;
  }
  function creaDlg() {
    dlg = document.createElement('dialog');
    dlg.className = 'erd-cmp-dlg';
    dlg.setAttribute('aria-labelledby', 'ErdCmpT');
    dlg.innerHTML = '<div class="erd-cmp-dlg__h"><div><h2 id="ErdCmpT"></h2><p data-sub></p></div>' +
      '<label class="erd-cmp-diff"><input type="checkbox" data-diff> Solo differenze</label>' +
      '<button type="button" class="erd-cmp-dlg__x" data-x aria-label="Chiudi il confronto">×</button></div>' +
      '<div class="erd-cmp-dlg__b" data-b></div>';
    document.body.appendChild(dlg);
    $('[data-x]', dlg).addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    $('[data-diff]', dlg).addEventListener('change', function (e) { dlg.classList.toggle('is-diff', e.target.checked); filtraDiff(); });
    $('[data-b]', dlg).addEventListener('click', azioniTabella);
  }
  function filtraDiff() {
    var on = $('[data-diff]', dlg).checked;
    $$('tr[data-same]', dlg).forEach(function (r) { r.hidden = on && r.getAttribute('data-same') === '1' || (r.classList.contains('is-extra') && !dlg.classList.contains('is-tutte')); });
  }
  function apriConfronto(cat) {
    if (!FAMIGLIE[cat] || lista(cat).length < 1) return;
    if (!dlg) creaDlg();
    var f = FAMIGLIE[cat], l = lista(cat).slice();
    $('#ErdCmpT', dlg).textContent = 'Confronta ' + f.nome.toLowerCase();
    $('[data-sub]', dlg).textContent = l.length + (l.length === 1 ? ' prodotto' : ' prodotti') + ' · dati delle schede Endurrad';
    $('[data-b]', dlg).innerHTML = '<p class="erd-cmp-load">Carico i dati dei prodotti…</p>';
    $('[data-diff]', dlg).checked = false; dlg.classList.remove('is-diff', 'is-tutte');
    dlg.setAttribute('data-cat', cat);
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    Promise.all(l.map(function (x) { return dati(x.h); })).then(function (rs) {
      /* si tolgono solo i prodotti eliminati o passati a un'altra famiglia; un errore di rete non svuota il confronto */
      l.forEach(function (x, i) { var r = rs[i]; if (r && (r.mancante || (r.cat && r.cat !== cat))) togli(cat, x.h); });
      var ps = rs.filter(function (r) { return r && !r.mancante && (!r.cat || r.cat === cat); });
      if (!ps.length) { $('[data-b]', dlg).innerHTML = '<p class="erd-cmp-load">Non riusciamo a caricare i dati in questo momento. Riprova tra poco.</p>'; return; }
      var nota = ps.some(function (p) { return p.parziale; }) ? '<p class="erd-cmp-dlg__f" style="padding-top:0;padding-bottom:12px">Per alcuni prodotti vedi solo prezzo e disponibilità: le caratteristiche sono nella scheda.</p>' : '';
      $('[data-b]', dlg).innerHTML = nota + tabella(cat, ps);
      filtraDiff();
    });
  }

  function valore(s) {
    if (!s) return null;
    var v = String(s.v || '').trim(), u = String(s.u || '').trim();
    if (u && v && v.slice(-u.length).toLowerCase() !== u.toLowerCase()) v += ' ' + u;
    return { v: v, d: String(s.d || '').trim() };
  }
  function trova(p, re, usate) {
    var specs = p.specs || [];
    for (var i = 0; i < specs.length; i++) {
      var e = norm(specs[i].e);
      if (e && re.test(e) && String(specs[i].v || '').trim()) { usate[i] = true; return specs[i]; }
    }
    return null;
  }
  var CAMPANA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.9 1.9 0 0 0 3.4 0"/></svg>';

  function tabella(cat, ps) {
    var f = FAMIGLIE[cat], m = moto();
    var usate = ps.map(function () { return {}; });
    var h = '<table class="erd-cmp-t"><colgroup><col class="is-lab">';
    ps.forEach(function () { h += '<col class="is-p">'; });
    var vuote = Math.max(0, Math.min(MAX - ps.length, 1));
    if (vuote) h += '<col class="is-p">';
    h += '</colgroup><thead><tr><th scope="col"><span class="sr-only">Prodotto</span></th>';
    ps.forEach(function (p) {
      var piene = Math.round(p.rating || 0), stelle = '';
      for (var i = 1; i <= 5; i++) stelle += i <= piene ? '★' : '☆';
      var azione;
      if (p.available && p.variants === 1) azione = '<button type="button" class="erd-cmp-p__go" data-add="' + p.variantId + '"' + (p.pre ? ' data-pre="1"' : '') + '>' + (p.pre ? 'Pre-ordina' : 'Aggiungi al carrello') + '</button>';
      else if (p.available) azione = '<a class="erd-cmp-p__go" href="' + esc(p.url) + '">Scegli le opzioni</a>';
      else if (String(p.vendor || '').toUpperCase() !== 'LOBOO') azione = '<button type="button" class="erd-cmp-p__go" disabled style="opacity:.55;cursor:default">Esaurito</button>'; /* Avvisami solo LOBOO */
      else azione = '<button type="button" class="erd-cmp-p__go is-avv" data-avv="' + p.id + '" data-vid="' + p.variantId + '" data-multi="' + (p.variants > 1 ? 1 : 0) + '" data-url="' + esc(p.url) + '" data-titolo="' + esc(p.title) + '">' + CAMPANA + 'Avvisami</button>';
      h += '<th scope="col"><div class="erd-cmp-p">' +
        '<button type="button" class="erd-cmp-p__rm" data-rm="' + esc(p.handle) + '" aria-label="Togli dal confronto: ' + esc(p.title) + '">×</button>' +
        '<a class="erd-cmp-p__img" href="' + esc(p.url) + '" tabindex="-1">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
        '<span class="erd-cmp-p__v">' + esc(p.vendor) + (p.codice ? ' · <span class="erd-cmp-p__cod">' + esc(p.codice) + '</span>' : '') + '</span>' +
        '<a class="erd-cmp-p__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="erd-cmp-p__st">' + (p.ratingCount > 0 ? '<b aria-hidden="true">' + stelle + '</b> ' + String((+p.rating).toFixed(1)).replace('.', ',') + ' (' + p.ratingCount + ')' : '') + '</span>' +
        '<span class="erd-cmp-p__pr">' + (p.priceVaries ? '<small>da </small>' + soldi(p.priceMin) : soldi(p.price)) + (p.compare > p.price && !p.priceVaries ? '<s>' + soldi(p.compare) + '</s>' : '') + '</span>' +
        azione + '<span class="erd-cmp-p__err" data-err hidden></span></div></th>';
    });
    if (vuote) h += '<th scope="col"><a class="erd-cmp-add" href="' + esc(f.url) + '"><b>+</b>Aggiungi ' + esc(f.altri) + '</a></th>';
    /* riga compatta che resta in alto durante lo scorrimento: codice, marchio e prezzo */
    h += '</tr><tr class="is-mini"><th scope="col"><span class="sr-only">Codice</span></th>';
    ps.forEach(function (p) {
      h += '<th scope="col"><a href="' + esc(p.url) + '"><b>' + esc(p.codice || p.title) + '</b><span>' + esc(p.vendor) + ' · ' + (p.priceVaries ? 'da ' + soldi(p.priceMin) : soldi(p.price)) + '</span></a></th>';
    });
    if (vuote) h += '<th scope="col"></th>';
    h += '</tr></thead><tbody>';

    function riga(label, celle, cls) {
      var testi = celle.map(function (c) { return norm(String(c.t || '').replace(/<[^>]+>/g, '')); });
      var same = ps.length > 1 && testi.every(function (t) { return t === testi[0]; }) ? '1' : '0';
      var r = '<tr data-same="' + same + '"' + (cls ? ' class="' + cls + '"' + (cls === 'is-extra' ? ' hidden' : '') : '') + '><th scope="row">' + esc(label) + '</th>';
      celle.forEach(function (c) { r += '<td' + (c.vuoto ? ' class="is-vuoto"' : '') + '>' + c.html + '</td>'; });
      if (vuote) r += '<td></td>';
      return r + '</tr>';
    }
    function grp(t) { return '<tr class="is-grp"><th scope="rowgroup" colspan="' + (ps.length + 1 + vuote) + '">' + esc(t) + '</th></tr>'; }

    h += grp('Acquisto');
    h += riga('Disponibilità', ps.map(function (p) {
      var t, c;
      if (!p.available) { t = 'Esaurito'; c = 'is-out'; }
      else if (p.pre) { t = 'Pre-ordine'; c = 'is-pre'; }
      else if (p.qty === 1) { t = 'Ultimo pezzo'; c = 'is-low'; }
      else if (p.qty !== null && p.qty > 0 && p.qty <= 3) { t = 'Ultimi ' + p.qty + ' pezzi'; c = 'is-low'; }
      else { t = 'Disponibile'; c = ''; }
      return { t: t, html: '<span class="erd-cmp-disp ' + c + '">' + t + '</span>' };
    }));
    h += riga('Consegna', ps.map(function (p) {
      var t = !p.available ? '—' : p.pre ? 'Spedizione entro 1 mese' : p.veloce ? '2-3 giorni lavorativi' : '5 giorni lavorativi';
      var g = p.available && p.price >= 10000 ? '<small>Spedizione gratuita in Italia</small>' : '';
      return { t: t + g, html: esc(t) + g, vuoto: t === '—' };
    }));
    h += riga(m ? 'Per la tua ' + m.nome : 'Moto compatibili', ps.map(function (p) {
      var mod = Array.isArray(p.modelli) ? p.modelli : [];
      if (m) {
        var ok = p.universale || mod.some(function (x) { return norm(x) === norm(m.base); });
        if (ok) return { t: 'ok', html: '<span class="erd-cmp-ok">✓ Ok per la tua moto</span>' };
        if (mod.length) return { t: 'no', html: '<span class="erd-cmp-no">Non indicata dal produttore</span>' };
        return { t: 'verifica', html: '<span class="erd-cmp-no">Da verificare: scrivici</span>' };
      }
      if (p.universale) return { t: 'universale', html: 'Universale' };
      if (mod.length) return { t: mod.join('|'), html: mod.length === 1 ? esc(mod[0]) : mod.length + ' modelli<small>' + esc(mod.slice(0, 4).join(', ')) + (mod.length > 4 ? '…' : '') + '</small>' };
      return { t: '', html: '—', vuoto: true };
    }));
    if (ps.some(function (p) { return p.chiave && p.chiave.length; })) {
      h += riga('In breve', ps.map(function (p) {
        if (!p.chiave || !p.chiave.length) return { t: '', html: '—', vuoto: true };
        var hh = '<div class="erd-cmp-chips">' + p.chiave.map(function (k) { return '<span><b>' + esc(k.v) + (k.u ? ' ' + esc(k.u) : '') + '</b>' + esc(k.e) + '</span>'; }).join('') + '</div>';
        return { t: hh, html: hh };
      }));
    }

    h += grp('Caratteristiche');
    var righeFam = '';
    f.righe.forEach(function (rd) {
      var trovate = ps.map(function (p, i) { return trova(p, rd[1], usate[i]); });
      if (!trovate.some(Boolean)) return;
      righeFam += riga(rd[0], trovate.map(function (s) {
        var x = valore(s);
        if (!x) return { t: '', html: '—', vuoto: true };
        return { t: x.v, html: esc(x.v) + (x.d ? '<small>' + esc(x.d) + '</small>' : '') };
      }));
    });
    h += righeFam || riga('Dati tecnici', ps.map(function () { return { t: '', html: 'Vedi la scheda', vuoto: true }; }));

    /* Altre specifiche: tutte le etichette rimaste, nell'ordine in cui compaiono */
    var etichette = [], visto = {};
    ps.forEach(function (p, i) {
      (p.specs || []).forEach(function (s, k) {
        if (usate[i][k]) return;
        var e = norm(s.e);
        if (!e || visto[e] || /^(marca|codice|codice prodotto|codice articolo|codice modello|serie|modello|nome ufficiale|nome originale loboo|denominazione ufficiale|servizio)$/.test(e)) return;
        visto[e] = true; etichette.push(s.e);
      });
    });
    if (etichette.length) {
      h += '<tr class="is-grp"><th scope="rowgroup" colspan="' + (ps.length + 1 + vuote) + '"><button type="button" class="erd-cmp-p__go" style="display:inline-flex;margin:0;padding:6px 14px;font-size:12px;text-transform:none;letter-spacing:0" data-tutte="' + etichette.length + '" aria-expanded="false">Mostra altre ' + etichette.length + ' specifiche</button></th></tr>';
      etichette.forEach(function (lab) {
        var e = norm(lab);
        h += riga(lab, ps.map(function (p, i) {
          var specs = p.specs || [];
          for (var k = 0; k < specs.length; k++) {
            if (!usate[i][k] && norm(specs[k].e) === e) {
              var x = valore(specs[k]);
              return { t: x.v, html: esc(x.v) + (x.d ? '<small>' + esc(x.d) + '</small>' : '') };
            }
          }
          return { t: '', html: '—', vuoto: true };
        }), 'is-extra');
      });
    }
    h += '</tbody></table>';
    h += '<p class="erd-cmp-dlg__f">Dati dichiarati dai produttori e riportati nelle schede Endurrad. Hai un dubbio sulla compatibilità? <a href="https://wa.me/393393363676" target="_blank" rel="noopener nofollow">Scrivici su WhatsApp</a>.</p>';
    return h;
  }

  function azioniTabella(e) {
    var t = e.target.closest('button');
    if (!t) return;
    var cat = dlg.getAttribute('data-cat');
    if (t.hasAttribute('data-rm')) {
      togli(cat, t.getAttribute('data-rm'));
      if (lista(cat).length) apriConfronto(cat); else dlg.close();
      return;
    }
    if (t.hasAttribute('data-tutte')) {
      var on = !dlg.classList.contains('is-tutte');
      dlg.classList.toggle('is-tutte', on);
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      t.textContent = on ? 'Nascondi le altre specifiche' : 'Mostra altre ' + t.getAttribute('data-tutte') + ' specifiche';
      $$('tr.is-extra', dlg).forEach(function (r) { r.hidden = !on || ($('[data-diff]', dlg).checked && r.getAttribute('data-same') === '1'); });
      return;
    }
    if (t.hasAttribute('data-avv')) {
      if (t.getAttribute('data-multi') === '1') { window.location.href = t.getAttribute('data-url') + '#avvisami'; return; }
      if (window.erdAvvisami) window.erdAvvisami.apri({ productId: t.getAttribute('data-avv'), variantId: t.getAttribute('data-vid'), titolo: t.getAttribute('data-titolo') }, t);
      return;
    }
    if (t.hasAttribute('data-add')) {
      var err = $('[data-err]', t.parentNode);
      var item = { id: +t.getAttribute('data-add'), quantity: 1 };
      if (t.getAttribute('data-pre') === '1') item.properties = { 'Pre-ordine': 'Spedizione entro 1 mese' };
      t.setAttribute('aria-busy', 'true'); t.disabled = true; if (err) err.hidden = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          dlg.close();
          try { if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'erd-confronta', cart: cart }); } catch (x) {}
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.show === 'function') setTimeout(function () { d.show(); }, 300);
          else window.location.href = '/cart';
        })
        .catch(function (x) { if (err) { err.textContent = (x && (x.description || x.message)) || 'Non siamo riusciti ad aggiungerlo. Riprova.'; err.hidden = false; } })
        .then(function () { t.removeAttribute('aria-busy'); t.disabled = false; });
    }
  }

  function init() {
    pulsantePdp();
    aggiorna();
    if (mo) mo.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', barraAcquisto, { passive: true });
    /* un'altra scheda del browser ha cambiato il confronto */
    window.addEventListener('storage', function (e) { if (e.key === CHIAVE) { stato = leggi(); aggiorna(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.erdConfronta = { apri: function (cat) { apriConfronto(cat || stato.cat); }, famiglie: FAMIGLIE };
})();
